var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cookies-wrap flex align-center",class:{
  hidden: !_vm.isCookieMessageVisible || !_vm.isFrontend
}},[_c('div',{staticClass:"text"},[_vm._v("\n    We use cookies to improve our users experience. "),_c('span',{staticClass:"agree",on:{"click":_vm.cookieStateToggle}},[_vm._v("Agree")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }